import { render, staticRenderFns } from "./NumberBox.vue?vue&type=template&id=90845c74&scoped=true&"
import script from "./NumberBox.vue?vue&type=script&lang=js&"
export * from "./NumberBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90845c74",
  null
  
)

export default component.exports